import { render, staticRenderFns } from "./QuestionResponseContent.vue?vue&type=template&id=bc0b3fe0"
import script from "./QuestionResponseContent.vue?vue&type=script&lang=js"
export * from "./QuestionResponseContent.vue?vue&type=script&lang=js"
import style0 from "./QuestionResponseContent.vue?vue&type=style&index=0&id=bc0b3fe0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports